import { useCallback } from "react";
var DEFER_TIME = 0;
export function useDebounce() {
    var debounce = useCallback(function (baseFunc) {
        var newTimer = window.setTimeout(function () {
            baseFunc();
        }, DEFER_TIME) || null;
        return newTimer;
    }, []);
    return { debounce: debounce };
}
